<ng-container>
  <ng-container *ngIf="initialized">
    <ng-container *ngIf="tenderList && tenderList.length > 0; else noTenders">
      <div class="container-fluid mt-5">
        <div class="row mt-5 pt-5 pb-5">
          <ng-container *ngTemplateOutlet="tenderFilter"></ng-container>
        </div>
        <div class="row">
          <div class="col-12">
            <p-tabView>
              <p-tabPanel cache="false" header="{{
                  'TenderEvaluation.tenderList.title'| translate
                }}">
                <ng-template pTemplate="content">
                  <ng-container *ngTemplateOutlet="tenderListTemplate"></ng-container>
                </ng-template>
              </p-tabPanel>
              <p-tabPanel cache="false" header="{{ 'TenderEvaluation.criteria.title' | translate }}">
                <ng-template pTemplate="content">
                  <ng-container *ngTemplateOutlet="criterialListTemplate"></ng-container>
                </ng-template>
              </p-tabPanel>
            </p-tabView>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <!-- TEMPLATE QUE SE MUESTRA CUANDO NO HAY OFERTAS-->
  <ng-template #noTenders>
    <ng-container
      *ngTemplateOutlet="tenderMessage;context: { message: this.translateService.instant('TenderEvaluation.noTenders') }">
    </ng-container>
  </ng-template>
  <ng-template #noFilteredTenders>
    <ng-container
      *ngTemplateOutlet="tenderMessage;context: { message: this.translateService.instant('TenderEvaluation.filter.noResults') }">
    </ng-container>
  </ng-template>
  <ng-template #tenderMessage let-message="message">
    <div class="row mt-2">
      <div class="col-12">
        <div class="widget style1 bg-info">
          <div class="row">
            <div class="col-4">
              <i class="fas fa-info fa-3x"></i>
            </div>
            <div class="col-8 text-right">
              <h2 class="font-bold">
                <div>{{message}}</div>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
<ng-template #tenderListTemplate>
  <div class="row m-t-md" *ngIf="filteredTenders && filteredTenders.length > 0; else noFilteredTenders">
    <div class="col-12">
      <p-panel class="mb-3" *ngFor="let tender of filteredTenders" [toggleable]="true"
        [(collapsed)]="panelStatus[tender.identifier]" (onBeforeToggle)="togglePanel(tender.identifier, $event)">
        <!-- A) TITULO OFERTA -->
        <p-header>
          <span>
            <i class="fa fas fa-lg fa-thumbs-up text-success" *ngIf="tender.state === TenderStateDTO.ACCEPTED"></i>
            <i class="fa fas fa-lg fa-thumbs-down text-danger" *ngIf="tender.state === TenderStateDTO.REJECTED"></i>
            <i class="fa fas fa-lg fa-pen"
              *ngIf="tender.state !== TenderStateDTO.REJECTED && tender.state !== TenderStateDTO.ACCEPTED"></i>
            <span class="cif ml-2">[{{ tender.company.taxIdentifier }}]</span> - <span>{{ getCompanyDescription(tender)
              }}</span>
          </span>
        </p-header>
        <h2 class="m-t-md">{{'TenderEvaluation.tenderList.info' | translate}}</h2>
        <div class="row m-t-md">
          <div class="col-12 col-md-6">
            <dl class="row">
              <dt class="col-12 col-md-6">{{ 'TenderInfo.registerNumber' | translate }}:</dt>
              <dd class="col-12 col-md-6">
                <span *ngIf="tender.numRegister">{{ tender.numRegister }}</span>
              </dd>
              <dt class="col-12 col-md-6">{{ 'TenderInfo.registerDate' | translate }}:</dt>
              <dd class="col-12 col-md-6">
                <span *ngIf="tender.dateTender">{{ tender.dateTender | date: 'dd-MM-yyyy HH:mm:ss' }}</span>
              </dd>
              <dt class="col-12 col-md-6">{{ 'General.state' | translate }}:</dt>
              <dd class="col-12 col-md-6">
                <span>{{ 'TenderStateDTO.' + tender.state | translate }}</span>
              </dd>
            </dl>
          </div>
          <div class="col-12 col-md-6" *ngIf="!hasLots">
            <div class="row">
              <div class="col-6"> {{'TenderEvaluation.lowTender' | translate}} </div>
              <div class="col-6">
                <p-dropdown [options]="triStateModel" (onChange)="lowTender($event.value, tender)"
                  [ngModel]="tender.tendersLots && tender.tendersLots.length > 0 && tender.tendersLots[0].recklessLow"
                  [disabled]="isNotEditing() ? false : true">
                </p-dropdown>
              </div>
            </div>
            <div class="m-t-md" *ngIf="tender.state === TenderStateDTO.INITIAL">
              <button class="text-center btn btn-sm btn-outline-secondary" aria-expanded="false"
                [attr.disabled]="isNotEditing() ? null: 'disabled'" (click)="rejectTenderState(tender)" appNoDblClick>
                <i [ngClass]="'fas fa-times'"></i> {{ 'TenderEvaluation.reject'| translate }} </button>
              <button class="ml-1 text-center btn btn-sm btn-primary" aria-expanded="false"
                [attr.disabled]="isNotEditing() ? null: 'disabled'" (click)="acceptTenderState(tender)" appNoDblClick>
                <i [ngClass]="'fa fa-check'"></i> {{ 'TenderEvaluation.accept' | translate }} </button>
            </div>
            <div class="m-t-md"
              *ngIf="tender.state === TenderStateDTO.ACCEPTED || tender.state === TenderStateDTO.REJECTED">
              <button class="text-center btn btn-sm btn-primary" aria-expanded="false"
                [attr.disabled]="isNotEditing() ? null: 'disabled'" (click)="changeTenderState(tender)" appNoDblClick>
                <i [ngClass]="(tender.state === TenderStateDTO.ACCEPTED)?'fas fa-times':'fa fa-check'"></i> {{
                ((tender.state === TenderStateDTO.ACCEPTED)? 'TenderEvaluation.reject' : 'TenderEvaluation.accept') |
                translate}} </button>
            </div>
          </div>
        </div>
        <ng-container *ngIf="hasLots && tender.tendersLots && tender.tendersLots.length > 0">
          <h2>{{'TenderEvaluation.lots.title' | translate}}</h2>
          <div class="lotes">
            <p-table [value]="tender.tendersLots" sortField="identifier" [responsive]="true" dataKey="identifier"
              [editMode]="'row'">
              <ng-template pTemplate="header">
                <tr>
                  <th [style.width]="'30%'">{{ lotsColHeaders[0] | translate }}</th>
                  <th class="text-center" [style.width]="'15%'">{{ lotsColHeaders[1] | translate }}</th>
                  <th class="text-center" [style.width]="'25%'">{{ lotsColHeaders[2] | translate }}</th>
                  <th class="text-center" [style.width]="'10%'">{{ lotsColHeaders[3] | translate }}</th>
                  <th [style.width]="'10%'">
                    <div *ngIf="hasInitialStateLots(tender)" class="text-center">
                      <button class="btn btn-sm btn-secondary t-action-butt"
                        (click)="menu.toggle($event);loadGroupActions (tender);">
                        <i class="fa fa-cog dropdown-toggle" aria-hidden="true"></i> {{
                        'TendeDocuments.Lots.Actions'|translate }}
                      </button>
                      <p-menu #menu [model]="groupActions" [popup]="true" appendTo="body"></p-menu>
                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-lot let-editing="editing" let-ri="rowIndex">
                <tr [pEditableRow]="lot">
                  <td>
                    <span class="p-column-title">{{ lotsColHeaders[0] | translate }}</span> {{ getLotDescription(lot)}}
                  </td>
                  <td class="text-center">
                    <span class="p-column-title">{{ lotsColHeaders[1] | translate }}</span>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-dropdown [options]="tenderLotStates" [(ngModel)]="lot.state">
                        </p-dropdown>
                      </ng-template>
                      <ng-template pTemplate="output"> {{('TenderLotState.' + lot.state) | translate}} </ng-template>
                    </p-cellEditor>
                  </td>
                  <td class="text-center">
                    <span class="p-column-title">{{ lotsColHeaders[2] | translate }}</span>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <textarea class="w-100" [autoResize]="true" [rows]="1" [cols]="20"
                          [(ngModel)]="lot.motivationState" pInputTextarea></textarea>
                      </ng-template>
                      <ng-template pTemplate="output"> {{lot.motivationState}} </ng-template>
                    </p-cellEditor>
                  </td>
                  <td>
                    <span class="p-column-title">{{ lotsColHeaders[3] | translate }}</span>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-dropdown [options]="triStateModel" [(ngModel)]="lot.recklessLow">
                        </p-dropdown>
                      </ng-template>
                      <ng-template pTemplate="output">
                        <div class="col-10 text-center">
                          {{
                          (
                          (!lot.recklessLow || lot.recklessLow === TriStateDTO.UNDEFINED) ?
                          'General.undefined'
                          :
                          (
                          (lot.recklessLow=== TriStateDTO.YES) ?
                          'General.yes' : 'General.no'
                          )
                          )
                          | translate
                          }}
                        </div>
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td class=" text-center">
                    <div class="btn-group">
                      <button *ngIf="!editing" pButton type="button" pInitEditableRow icon="fa fa-pencil"
                        class="t-action-button" (click)="onLotEditInit(lot)" appNoDblClick
                        title="{{ 'General.edit' | translate }}"
                        [attr.disabled]="isNotEditing() ? null: 'disabled'"></button>
                      <button *ngIf="editing" pButton type="button" pCancelEditableRow icon="fas fa-times"
                        class="btn btn-sm btn-primary t-action-button" (click)="onLotEditCancel(lot)" appNoDblClick
                        title="{{ 'General.cancel' | translate }}"></button>
                      <button *ngIf="editing" pButton type="button" pSaveEditableRow icon="fa fa-save"
                        class="btn btn-sm btn-primary t-action-button" (click)="onLotEditSave(lot, tender)"
                        title="{{ 'General.save' | translate }}" appNoDblClick></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </ng-container>
        <h2 class="mt-2">{{'TenderEvaluation.documentation.title' | translate }}</h2>
        <ng-container
          *ngTemplateOutlet="tenderEnvelopes; context: { tenderEnvelopes: loadedTenderEnvelopes.get(tender.identifier), tender: tender}">
        </ng-container>
      </p-panel>
    </div>
  </div>
</ng-template>
<ng-template #criterialListTemplate>
  <tenderCriteria [project]="project" [tenderList]="filteredTenders" (criteriaUpdated)="updateDossierTenders()">
  </tenderCriteria>
</ng-template>
<ng-template #tenderFilter>
  <p-fieldset legend="{{'TenderEvaluation.filter.title' | translate}}" class="col-12">
    <div class="row">
      <div class="col-12 col-md-1">{{'TenderInfo.company' | translate}}</div>
      <div class="col-12 col-md-5">
        <p-multiSelect defaultLabel="{{ 'General.select' | translate }}" [options]="companyValues" dataKey="identifier"
          optionLabel="description" [(ngModel)]="filter.companies" (onChange)="filterTenderList()"
          [disabled]="isNotEditing() ? false : true">
        </p-multiSelect>
      </div>
      <div class="col-12 col-md-1">{{ 'TenderEvaluation.filter.states' | translate }}:</div>
      <div class="col-12 col-md-5">
        <p-multiSelect defaultLabel="{{ 'General.select' | translate }}" [options]="tenderStates"
          [(ngModel)]="filter.state" (onChange)="filterTenderList()" [disabled]="isNotEditing() ? false : true">
        </p-multiSelect>
      </div>
      <div class="col-12 col-md-1 m-t-xs" *ngIf="hasLots">{{ 'TenderEvaluation.filter.lots' | translate }}:</div>
      <div class="col-12 col-md-5 m-t-xs" *ngIf="hasLots">
        <p-multiSelect defaultLabel="{{ 'General.select' | translate }}" [options]="filterLotValues"
          dataKey="identifier" [(ngModel)]="filter.lots" (onChange)="filterTenderList()"
          [disabled]="isNotEditing() ? false : true">
        </p-multiSelect>
      </div>
    </div>
  </p-fieldset>
</ng-template>
<!-- B) TABLA DE SOBRES -->
<ng-template #tenderEnvelopes let-tenderEnvelopes="tenderEnvelopes" let-tender="tender">
  <p-table [value]="tenderEnvelopes" sortField="order" dataKey="customIdentifier" [responsive]="true"
    [expandedRowKeys]="expandedRows">
    <ng-template pTemplate="header">
      <tr>
        <th [style.width]="'2%'"></th>
        <th [style.width]="'43%'"> {{ envelopeColHeaders[0] | translate }} </th>
        <th [style.width]="'25%'"> {{ envelopeColHeaders[1] | translate }} </th>
        <th [style.width]="'30%'" *ngIf="project?.breakdownLot?.apportioned"> {{ envelopeColHeaders[2] | translate }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-envelope let-expanded="expanded" let-rowIndex="rowIndex">
      <tr>
        <td>
          <a href="#" [pRowToggler]="envelope">
            <i [ngClass]="
                      expanded ? 'fas fa-1-5x fa-chevron-down' : 'fas fa-1-5x fa-chevron-right'
                    "></i>
          </a>
        </td>
        <td>
          <span class="p-column-title">{{ envelopeColHeaders[0] | translate }}</span>
          <i class="fa far fa-lg fa-envelope" aria-hidden="true"></i> {{ envelope.description }} <i
            class="fas fa-lg fa-exclamation-circle text-warning " *ngIf="hasCorrectedDocumensts(tender, envelope)"
            pTooltip="{{ 'TenderEvaluation.envelopes.hasCorrectedDocuments' | translate }}"></i>
        </td>
        <td>
          <span class="p-column-title">{{ envelopeColHeaders[1] | translate }}</span> {{ envelope.type.description }}
        </td>
        <td *ngIf="project?.breakdownLot?.apportioned">
          <span class="p-column-title">{{ envelopeColHeaders[2] | translate }}</span> {{ this.getLots(envelope) }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr class="text-center">
        <td [attr.colspan]="this.envelopeColHeaders.length + 1"> {{ 'General.noData' | translate }} </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-envelope>
      <tr>
        <td [attr.colspan]="this.envelopeColHeaders.length + 1">
          <!-- C) TABLA DOCUMENTOS (ITERANDO POR SOBRE) -->
          <ng-container *ngTemplateOutlet="envelopeDocs; context: { tender: tender, envelope: envelope}">
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>
<ng-template #envelopeDocs let-tender="tender" let-envelope="envelope">
  <p-table #panel [value]="getTenderEnvelopeDocuments(tender, envelope)" class="footer-over-pagination mb-3"
    dataKey="identifier" editMode="row">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th class="TEXTTH-w200"> {{ 'TenderEvaluation.documents.name' | translate }} </th>
        <th class="text-center col-icon"> {{ 'TenderEvaluation.documents.included' | translate }} </th>
        <th class="text-center col-icon"> {{ 'TenderEvaluation.documents.correct' | translate }} </th>
        <th class="TEXTTH-w200"> {{ 'TenderEvaluation.documents.observations' | translate }} </th>
        <th class="text-right action-column-2"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-editing="editing">
      <tr [pEditableRow]="rowData">
        <td class="TEXTTH-w200">
          <span class="p-column-title">{{ 'TenderEvaluation.documents.name' | translate }}</span>
          <i class="fas fa-lg fa-info-circle text-info" *ngIf="rowData.description" (click)="
                                  uiService.showMessage(
                                    rowData.description,
                                    'Descripción del documento'
                                  )
                                "></i>
          <span *ngIf="rowData.fixedFile" class="badge badge-info">{{'TenderEvaluation.documents.fixed' | translate}}
          </span>
          <tenderDocumentDetail [documentV1]="rowData"></tenderDocumentDetail>
        </td>
        <td class="text-center col-icon">
          <span class="p-column-title">{{ 'TenderEvaluation.documents.included' | translate }}</span>
          <span><i class="far fa-lg" [ngClass]="(rowData.included) ? 'fa-check-square':'fa-square'"
              [attr.aria-label]="translateService.instant((rowData.included)?'General.yes':'General.no')"></i></span>
        </td>
        <td class="text-center col-icon">
          <span class="p-column-title">{{ 'TenderEvaluation.documents.correct' | translate }}</span>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-dropdown [options]="yesNoModel" [(ngModel)]="rowData.corrected">
              </p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">
              <span><i class="far fa-lg" [ngClass]="(rowData.corrected) ? 'fa-check-square':'fa-square'"
                  [attr.aria-label]="translateService.instant((rowData.corrected)?'General.yes':'General.no')"></i></span>
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="TEXTTH-w200">
          <span class="p-column-title">{{ 'TenderEvaluation.documents.observations' | translate }}</span>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <textarea class="w-100" [autoResize]="true" [rows]="1" [cols]="20" [(ngModel)]="rowData.observations"
                pInputTextarea></textarea>
            </ng-template>
            <ng-template pTemplate="output"> {{rowData.observations}} </ng-template>
          </p-cellEditor>
        </td>
        <td class="text-right action-column-2">
          <div class="btn-group">
            <button *ngIf="!editing" pButton type="button" pInitEditableRow icon="fa fa-pencil" class="t-action-button"
              (click)="onDocEditInit(rowData)" appNoDblClick title="{{ 'General.edit' | translate }}"
              [attr.disabled]="isNotEditing() ? null: 'disabled'"></button>
            <!-- botones para ver documento incluido -->
            <button *ngIf="!editing && rowData.file && documentService.isPdf(rowData.file)"
              class="btn btn-sm t-action-button btn-primary" aria-expanded="false" (click)="viewFile(rowData.file)"
              appNoDblClick title="{{ 'General.visualize' | translate }}"
              [attr.disabled]="isNotEditing() ? null: 'disabled'">
              <i class="fa fa-eye" aria-hidden="true"></i>
            </button>
            <button *ngIf="!editing && rowData.file && !documentService.isPdf(rowData.file)"
              class="btn btn-sm t-action-button btn-primary" aria-expanded="false"
              (click)="downloadEmbedded(rowData.file)" appNoDblClick title="{{ 'General.download' | translate }}"
              [attr.disabled]="isNotEditing() ? null: 'disabled'">
              <i class="fas fa-download" aria-hidden="true"></i>
            </button>
            <!-- botones para ver documento subsanado -->
            <button *ngIf="!editing && rowData.fixedFile" class="btn btn-sm t-action-button btn-primary"
              aria-expanded="false" (click)="viewFile(rowData.fixedFile)" appNoDblClick
              title="{{ 'General.download' | translate }}" [attr.disabled]="isNotEditing() ? null: 'disabled'">
              <i class="fas fa-history"></i>
            </button>
            <!-- botones de edicion-->
            <button *ngIf="editing" pButton type="button" pCancelEditableRow icon="fas fa-times"
              class="btn btn-sm btn-primary t-action-button" (click)="onDocEditCancel(rowData)" appNoDblClick
              title="{{ 'General.cancel' | translate }}"></button>
            <button *ngIf="editing" pButton type="button" pSaveEditableRow icon="fa fa-save"
              class="btn btn-sm btn-primary t-action-button" (click)="onDocEditSave(rowData)" appNoDblClick
              title="{{ 'General.save' | translate }}"></button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr class="text-center">
        <td [attr.colspan]="5"> {{ 'General.noData' | translate }} </td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>